module.exports = __webpack_public_path__ + "static/media/user-dark.2b143eb9.svg";